'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dGet$002dProvider$002dResponse from "./presto.types$proto$-Get-Provider-Response.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$GetProviderResponse$() {
}
export { $c_Lpresto_types$proto$GetProviderResponse$ as $c_Lpresto_types$proto$GetProviderResponse$ };
$p = $c_Lpresto_types$proto$GetProviderResponse$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$GetProviderResponse$;
/** @constructor */
function $h_Lpresto_types$proto$GetProviderResponse$() {
}
export { $h_Lpresto_types$proto$GetProviderResponse$ as $h_Lpresto_types$proto$GetProviderResponse$ };
$h_Lpresto_types$proto$GetProviderResponse$.prototype = $p;
$p.l = (function() {
  return "GetProviderResponse";
});
$p.cHP = (function(x$0) {
  return new $j_presto$002etypes$0024proto$0024$002dGet$002dProvider$002dResponse.$c_Lpresto_types$proto$GetProviderResponse(x$0.j(0), x$0.j(1), x$0.j(2));
});
var $d_Lpresto_types$proto$GetProviderResponse$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$GetProviderResponse$, "presto.types$proto$GetProviderResponse$", ({
  a3n: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$proto$GetProviderResponse$ as $d_Lpresto_types$proto$GetProviderResponse$ };
var $n_Lpresto_types$proto$GetProviderResponse$;
function $m_Lpresto_types$proto$GetProviderResponse$() {
  if ((!$n_Lpresto_types$proto$GetProviderResponse$)) {
    $n_Lpresto_types$proto$GetProviderResponse$ = new $c_Lpresto_types$proto$GetProviderResponse$();
  }
  return $n_Lpresto_types$proto$GetProviderResponse$;
}
export { $m_Lpresto_types$proto$GetProviderResponse$ as $m_Lpresto_types$proto$GetProviderResponse$ };
//# sourceMappingURL=presto.types$proto$-Get-Provider-Response$.js.map
